import esLocales from './lan/es';
import itLocales from './lan/it';

const locales = {
    es: esLocales,
    it: itLocales,
    en: {}
}

export default locales;